<template>
  <span class="logo">
      <router-link to="/"><img src="../../assets/images/pc/logo.png" alt=""></router-link>
  </span>
</template>

<script>
export default {
  name: 'Logo',
}
</script>

<style scoped lang="less">
  .logo {
    font-size: 30px;
    font-weight: bold;

    img {
      vertical-align: middle;
      height:24px;
      width: 240px;
      display: inline-block;
    }

    a {
      display: inline-block;
      color: #fff;
      font-size: 28px;
      font-weight: bold;
    }

    .BVC {
      color: #fff;
    }
  }
</style>
